export default [
  {
    path: '/delegations',
    name: 'delegation-list',
    props: true,
    component: () => import('@/views/location/delegations/Index.vue'),
    meta: {
      admin: true,
      requireLogin: true,
      pageTitle: 'Liste des délégations',
      ariaLabel: 'Tableau des délégations logistiques',
      pageDesc: 'Consultez, filtrez et gérez les délégations pour la logistique et la distribution. Utilisez les filtres avancés pour affiner la recherche. Les actions incluent l’activation, la désactivation et la modification des informations territoriales.',
      breadcrumb: [
        {
          text: 'Délégations',
          to: { name: 'delegation-list' },
          ariaLabel: 'Retour à la liste des délégations',
        },
        {
          text: 'Liste',
          active: true,
          ariaLabel: 'Tableau principal des délégations',
        },
      ],
      roles: ['admin', 'superadmin'],
      breadcrumbLabel: 'Liste des délégations',
    },
  },
  {
    path: '/delegations/create',
    name: 'delegation-add',
    component: () => import('@/views/location/delegations/Create.vue'),
    meta: {
      admin: true,
      requireLogin: true,
      pageTitle: 'Ajouter une délégation',
      ariaLabel: 'Formulaire d’ajout de délégation logistique',
      pageDesc: 'Ajoutez une nouvelle délégation en renseignant les informations territoriales requises. Utilisez une terminologie logistique professionnelle.',
      breadcrumb: [
        {
          text: 'Délégations',
          to: { name: 'delegation-list' },
          ariaLabel: 'Retour à la liste des délégations',
        },
        {
          text: 'Ajouter',
          active: true,
          ariaLabel: 'Formulaire d’ajout de délégation',
        },
      ],
      roles: ['admin', 'superadmin'],
      breadcrumbLabel: 'Ajouter délégation',
    },
  },
  {
    path: '/delegations/edit/:id',
    name: 'delegation-edit',
    component: () => import('@/views/location/delegations/Edit.vue'),
    meta: {
      admin: true,
      requireLogin: true,
      pageTitle: 'Modifier une délégation',
      ariaLabel: 'Formulaire de modification de délégation logistique',
      pageDesc: 'Modifiez les informations territoriales de la délégation en respectant la terminologie logistique professionnelle. Les champs obligatoires sont signalés.',
      breadcrumb: [
        {
          text: 'Délégations',
          to: { name: 'delegation-list' },
          ariaLabel: 'Retour à la liste des délégations',
        },
        {
          text: 'Modifier',
          active: true,
          ariaLabel: 'Formulaire de modification de délégation',
        },
      ],
      roles: ['admin', 'superadmin'],
      breadcrumbLabel: 'Modifier délégation',
    },
  },
  {
    path: '/delegations/detail/:id',
    name: 'delegation-detail',
    props: true,
    component: () => import('@/views/location/delegations/Detail.vue'),
    meta: {
      admin: true,
      requireLogin: true,
      pageTitle: 'Détails de la délégation',
      ariaLabel: 'Détails de la délégation logistique',
      pageDesc: 'Consultez les informations détaillées de la délégation, y compris les localités, les statistiques logistiques et l’état d’activation. Utilisez les boutons d’action pour modifier ou changer le statut.',
      breadcrumb: [
        {
          text: 'Délégations',
          to: { name: 'delegation-list' },
          ariaLabel: 'Retour à la liste des délégations',
        },
        {
          text: 'Détails',
          active: true,
          ariaLabel: 'Page de détails de la délégation',
        },
      ],
      roles: ['admin', 'superadmin'],
      breadcrumbLabel: 'Détails délégation',
    },
  },
]
